import * as types from "../types/index";
import { setInitialState } from "../InitialState";

const INITIAL_STATE = setInitialState({
  data: null,
});

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.CONTACT_US_BUTTON_REQUEST:
      return {
        ...state,
        isFetching: true,
        isError: false,
        isSuccess: false,
      };
    case types.CONTACT_US_BUTTON_RECEIVE:
      return {
        ...state,
        isFetching: false,
        isError: false,
        isSuccess: true,
        data: action.payload.success,
      };
    case types.CONTACT_US_BUTTON_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true,
        isSuccess: false,
        data: action.payload.response.error,
      };
    case types.RESET_CONTACT_US_BUTTON:
      return {
        ...state,
        isFetching: false,
        isError: false,
        isSuccess: false,
        data: null,
      };
    default:
      return {
        ...state,
      };
  }
}
